import {ref} from 'vue'

const isSubmitting = ref(false);

const submittingProcess = () => {
    isSubmitting.value = true;
}

const resetSubmitFrom = () => {
    setTimeout(() => {
        isSubmitting.value = false;
    }, 1000);
}

export {
    submittingProcess, 
    resetSubmitFrom,
    isSubmitting
}